import { useSATConnection } from '../../features/sat-connection';
import { annualOwed, assumesPendingMonths, useDeclarationsSummary } from '../../features/declarations-new/summary';
import { isHeruDaysRegPromoActive } from './heruDaysReg';

const LAST_ANNUAL_YEAR = new Date().getFullYear() - 1;

// Gate del banner Heru Days (50% OFF en regularizaciones): solo a quien tiene
// MESES pendientes, AÑOS pendientes (obligación anual no adquirida) o NO está
// vinculado. Al no vinculado se lo mostramos — no conocemos sus pendientes y la
// promo es el gancho para que conecte. Mientras el overview no carga asumimos
// meses pendientes (mismo criterio que el banner del triunfo / FiscalInfoDrawer).
// Debe usarse dentro de <SATConnectionProvider>.
export const useIsHeruDaysRegPromoVisible = (): boolean => {
	const { isLinked } = useSATConnection();
	const summary = useDeclarationsSummary();

	if (!isHeruDaysRegPromoActive()) return false;
	if (!isLinked) return true;

	return assumesPendingMonths(summary) || annualOwed(summary, LAST_ANNUAL_YEAR);
};
